<div class="ir-area ir-mask th-mask" [open]="!isOpen" [attr.data-keyboard]="true" [attr.data-backdrop]="false">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content-flow has-footer th-content-flow--dark">
        <div
          class="ir-item-line th-order clickable indent-double"
          *ngFor="let item of items | orderBy: 'order':'asc'; let i = index"
        >
          <div class="ir-item-cell s4">
            <div class="ir-item-selector">
              <i class="material-icons" (click)="updateOrder(item, i, -1)">arrow_upward</i>
              <!--<i class="material-icons th-disabled" *ngIf="i == 0">arrow_upward</i>-->
              <i class="material-icons" (click)="updateOrder(item, i, 1)">arrow_downward</i>
              <!--<i class="material-icons th-disabled" *ngIf="i == items.length - 1">arrow_downward</i>-->
            </div>
            <span class="icon-label" *ngIf="item.type === 'folder'"
              ><i class="material-icons">folder</i> {{ item.name }}</span
            >
            <span *ngIf="item.type !== 'folder'">{{ item.name }}</span>
          </div>
          <div class="ir-item-cell s6"></div>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" (click)="save()">
            <span>{{ 'common.save' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
